"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnEscape_1 = require("./OnEscape");
exports.default = OnEscape_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/behaviors/OnEscape/index.js
// module id = 507
// module chunks = 8